"use client";

import { Cursor, useCursorState } from "motion-plus/react";

export function CursorComponent() {
  const { zone } = useCursorState();

  const createRingStyle = (size: number, opacity: number) => ({
    width: size,
    height: size,
    borderRadius: "50%",
    rotate: "90deg",
    background: `conic-gradient(from 90deg, rgba(69, 155, 191, 1) 0deg, rgba(192, 147, 69, 1) 55.3846deg, rgba(179, 98, 107, 1) 90deg, rgba(99, 100, 229, 1) 180deg, rgba(182, 100, 104, 1) 270deg, rgba(192, 147, 69, 1) 304.615deg, rgba(69, 155, 191, 1) 360deg)`,
    mask: `radial-gradient(circle, transparent ${size / 2 - 4}px, black ${size / 2 - 2}px)`,
    WebkitMask: `radial-gradient(circle, transparent ${size / 2 - 4}px, black ${size / 2 - 2}px)`,
    opacity: opacity,
  });

  // 只在 header zone 显示自定义光标
  if (zone !== "header") {
    return null;
  }

  return (
    <>
      <Cursor
        style={createRingStyle(32, 1)}
        variants={{
          pressed: { scale: 0.8 },
        }}
        spring={{ stiffness: 800, damping: 60 }}
      />
      <Cursor
        style={createRingStyle(32, 0.6)}
        variants={{
          pressed: { scale: 0.8 },
        }}
        spring={{ stiffness: 700, damping: 70 }}
      />
      <Cursor
        style={createRingStyle(32, 0.3)}
        variants={{
          pressed: { scale: 0.8 },
        }}
        spring={{ stiffness: 600, damping: 80 }}
      />
    </>
  );
}
